<template>
  <div>
    <common-dialog ref="dialog" width="800px" unit="激活名额"  id-key="PlaceId" :data="data" :form-rules="rules"
      form-label-width="85px"  :save-func="api.save" :get-data-func="api.info" close-on-saved
      @create-opened="onCreateOpened" @edit-opened="onEditOpened" @closed="onClosed" :before-save="onBeforeSave"
      @details-opened="onDetailsOpened" @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="归属机构" prop="DpId">
              <span>{{data.DpName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目" prop="Item">
              <span>{{data.Item}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="loginInfo.UserType!=1">
            <el-form-item label="操作日期" prop="PlaceDate">
              <span>{{$commonJs.toDateString(data.PlaceDate)}}</span>
            </el-form-item>
          </el-col>
        <!-- </el-row>
        <el-row> -->
          <el-col :span="12">
            <el-form-item label="操作类型" prop="PlaceType">
              <span v-if="data.PlaceType ==1">购买</span>
              <span v-if="data.PlaceType ==2">回收</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单价" prop="Price">
              <span>{{data.Price}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数量" prop="Quantity">
              <span>{{data.Quantity}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="金额" prop="Amount">
              <span>{{data.Amount}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="明细信息" prop="PlaceType">
              <el-table ref="place" :data="data.PlaceDtsDtos" border size="mini" style="margin: 7px 0 0;">
                <el-table-column prop="CarType" label="培训车型" align="center">
                </el-table-column>
                <el-table-column prop="Price" label="单价" align="center">
                  <template slot-scope="{row}">
                    <span>{{row.Price}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Quantity" label="数量" align="center">
                  <template slot-scope="{row}">
                    <span>{{row.Quantity}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Amount" label="金额" align="center" />
              </el-table>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <span>{{data.Remark}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <template v-if="$permission.canReview()">
          <el-button type="success" @click="pass" v-if="data.Status==1">通 过</el-button>
          <el-button type="danger" @click="back(1)" v-if="data.Status==1">退 回</el-button>
          <!-- <el-button type="danger" @click="back(2)" v-if="data.Status==3">撤销审批</el-button> -->
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <return-dialog ref="returnDialog" @confirm="toReturn" ></return-dialog>
  </div>
</template>

<script>
var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import api from "@/api/op/activeplace";
import returnDialog from "@/components/schoolmanage/dp/returnDialog";

  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      returnDialog,
    },
    data() {
      return {
        data: {
          PlaceId: 0,
          PlaceType: 1,
          PlaceDate: null,
          Remark: null,
          DpId: 0,
          DpName: "",
          Status: 0,
          Price: null,
          Quantity: null,
          Amount: 0,
          Item: "",
          PlaceDtsDtos: []
        },
        api,
        loginInfo,
        rules: {
          DpId: [{ required: true, message: "请选择所属组织" }],
          PlaceDate: [{ required: true, message: "请选择操作日期" }],
          PlaceType: [{ required: true, message: "请选择操作类型" }],
          Price: [{ required: true, message: "请填写单价" }],
          Quantity: [{ required: true, message: "请填写数量" }],
          Item: [{ required: true, message: "请选择项目" }],
        },
        TreeData: [],
      };
    },
    methods: {
      onCreateOpened() {
        
      },
      onEditOpened(data) {
        
      },
      onDetailsOpened(row) {
        this.onEditOpened(row)
      },
      pass() {
        this.$confirm("确认通过吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.loading(true);
            this.api.pass({ Id: this.data.PlaceId, Remark: "" }).then(res => {
              this.loading(false);
              if(res.Code==0) {
                this.$message.success("操作成功");
                this.close(true);
                this.$emit('close-saved');
              } else {
                this.$message.error(res.Msg);
              }
            })
          })
          .catch(() => {});
      },
      back(t) {
        this.backType = t;
        this.$refs.returnDialog.open(t);
      },
      toReturn(data) {
        this.loading(true);
        if(this.backType==1) {
          this.api.back({ Id: this.data.PlaceId, Remark: data.Remark }).then(res => {
            this.loading(false);
            if(res.Code==0) {
              this.$message.success(res.Msg);
              this.close(true);
              this.$emit('close-saved');
            } else {
              this.$message.error(res.Msg);
            }
          })
        } else {
          this.api.cancelReview({ Id: this.data.PlaceId, Remark: data.Remark }).then(res => {
            this.loading(false);
            if(res.Code==0) {
              this.$message.success(res.Msg);
              this.close(true);
              this.$emit('close-saved');
            } else {
              this.$message.error(res.Msg);
            }
          })
        }
      },
      onBeforeSave() {
        
      },
      onClosed() {
      },
    },
  };
</script>